export const educationData = [
    {
        id: 1,
        institution: 'University of Education Township Campus Lahore',
        course: 'Bachelors in Information Technology',
        startYear: '2018',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Royal College Of Science For Boys Narowal',
        course: 'FSC (Pre-Engineering)',
        startYear: '2016',
        endYear: '2018'
    },
    {
        id: 3,
        institution: 'Govt High School Narowal',
        course: 'Matric',
        startYear: '2014',
        endYear: '2016'
    }
]